export default "__VITE_ASSET__27eHOVz___"